import React from 'react';
import {Card, DataTable} from './primitives';
import type {OhdHba1cBreakdown} from '../types';
import {buildHba1cRows} from '../utils/computeYoY';

interface Props {
    current: OhdHba1cBreakdown;
    prior: OhdHba1cBreakdown | null;
    currentYear: string | number;
    priorYear: string | number | null;
}

const HbA1cTable: React.FC<Props> = ({current, prior, currentYear, priorYear}) => {
    const hasPrior = !!prior && !!priorYear;
    const rows = buildHba1cRows(current, prior);
    const headers = hasPrior
        ? [
              'Diabetic Risk',
              String(currentYear),
              `% in ${currentYear}`,
              String(priorYear),
              `% in ${priorYear}`,
              'Change',
          ]
        : ['Diabetic Risk', String(currentYear), `% in ${currentYear}`];

    const tableRows = rows.map((r) =>
        hasPrior
            ? [
                  r.risk,
                  r.current.toLocaleString(),
                  r.currentPct,
                  (r.prior ?? 0).toLocaleString(),
                  r.priorPct ?? '—',
                  r.change ?? '—',
              ]
            : [r.risk, r.current.toLocaleString(), r.currentPct]
    );

    return (
        <div>
            <h2 className="mb-2 text-[24px] text-mld-muted-text">HbA1c</h2>
            <Card>
                <div className="p-5">
                    <DataTable headers={headers} rows={tableRows} />
                </div>
            </Card>
        </div>
    );
};

export default HbA1cTable;
